// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sk-fading-circle {
    width: 2em;
    height: 2em;
    position: relative;
    margin: auto;
}

.sk-fading-small {
    width: 1.5em;
    height: 1.5em;
}

.sk-fading-circle .sk-circle {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
.sk-fading-circle .sk-circle:before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: #337ab7;
    border-radius: 100%;
    animation: sk-fading-circle-delay 1.2s infinite ease-in-out both;
}
.sk-fading-circle .sk-circle-2 {
    transform: rotate(30deg);
}
.sk-fading-circle .sk-circle-3 {
    transform: rotate(60deg);
}
.sk-fading-circle .sk-circle-4 {
    transform: rotate(90deg);
}
.sk-fading-circle .sk-circle-5 {
    transform: rotate(120deg);
}
.sk-fading-circle .sk-circle-6 {
    transform: rotate(150deg);
}
.sk-fading-circle .sk-circle-7 {
    transform: rotate(180deg);
}
.sk-fading-circle .sk-circle-8 {
    transform: rotate(210deg);
}
.sk-fading-circle .sk-circle-9 {
    transform: rotate(240deg);
}
.sk-fading-circle .sk-circle-10 {
    transform: rotate(270deg);
}
.sk-fading-circle .sk-circle-11 {
    transform: rotate(300deg);
}
.sk-fading-circle .sk-circle-12 {
    transform: rotate(330deg);
}
.sk-fading-circle .sk-circle-2:before {
    animation-delay: -1.1s;
}
.sk-fading-circle .sk-circle-3:before {
    animation-delay: -1s;
}
.sk-fading-circle .sk-circle-4:before {
    animation-delay: -0.9s;
}
.sk-fading-circle .sk-circle-5:before {
    animation-delay: -0.8s;
}
.sk-fading-circle .sk-circle-6:before {
    animation-delay: -0.7s;
}
.sk-fading-circle .sk-circle-7:before {
    animation-delay: -0.6s;
}
.sk-fading-circle .sk-circle-8:before {
    animation-delay: -0.5s;
}
.sk-fading-circle .sk-circle-9:before {
    animation-delay: -0.4s;
}
.sk-fading-circle .sk-circle-10:before {
    animation-delay: -0.3s;
}
.sk-fading-circle .sk-circle-11:before {
    animation-delay: -0.2s;
}
.sk-fading-circle .sk-circle-12:before {
    animation-delay: -0.1s;
}
@keyframes sk-fading-circle-delay {
    0%, 39%, 100% {
        opacity: 0;
    }
    40% {
        opacity: 1;
    }
}
`, "",{"version":3,"sources":["webpack://./_devapp/css/spinner.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;AACA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,gEAAgE;AACpE;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".sk-fading-circle {\n    width: 2em;\n    height: 2em;\n    position: relative;\n    margin: auto;\n}\n\n.sk-fading-small {\n    width: 1.5em;\n    height: 1.5em;\n}\n\n.sk-fading-circle .sk-circle {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n.sk-fading-circle .sk-circle:before {\n    content: '';\n    display: block;\n    margin: 0 auto;\n    width: 15%;\n    height: 15%;\n    background-color: #337ab7;\n    border-radius: 100%;\n    animation: sk-fading-circle-delay 1.2s infinite ease-in-out both;\n}\n.sk-fading-circle .sk-circle-2 {\n    transform: rotate(30deg);\n}\n.sk-fading-circle .sk-circle-3 {\n    transform: rotate(60deg);\n}\n.sk-fading-circle .sk-circle-4 {\n    transform: rotate(90deg);\n}\n.sk-fading-circle .sk-circle-5 {\n    transform: rotate(120deg);\n}\n.sk-fading-circle .sk-circle-6 {\n    transform: rotate(150deg);\n}\n.sk-fading-circle .sk-circle-7 {\n    transform: rotate(180deg);\n}\n.sk-fading-circle .sk-circle-8 {\n    transform: rotate(210deg);\n}\n.sk-fading-circle .sk-circle-9 {\n    transform: rotate(240deg);\n}\n.sk-fading-circle .sk-circle-10 {\n    transform: rotate(270deg);\n}\n.sk-fading-circle .sk-circle-11 {\n    transform: rotate(300deg);\n}\n.sk-fading-circle .sk-circle-12 {\n    transform: rotate(330deg);\n}\n.sk-fading-circle .sk-circle-2:before {\n    animation-delay: -1.1s;\n}\n.sk-fading-circle .sk-circle-3:before {\n    animation-delay: -1s;\n}\n.sk-fading-circle .sk-circle-4:before {\n    animation-delay: -0.9s;\n}\n.sk-fading-circle .sk-circle-5:before {\n    animation-delay: -0.8s;\n}\n.sk-fading-circle .sk-circle-6:before {\n    animation-delay: -0.7s;\n}\n.sk-fading-circle .sk-circle-7:before {\n    animation-delay: -0.6s;\n}\n.sk-fading-circle .sk-circle-8:before {\n    animation-delay: -0.5s;\n}\n.sk-fading-circle .sk-circle-9:before {\n    animation-delay: -0.4s;\n}\n.sk-fading-circle .sk-circle-10:before {\n    animation-delay: -0.3s;\n}\n.sk-fading-circle .sk-circle-11:before {\n    animation-delay: -0.2s;\n}\n.sk-fading-circle .sk-circle-12:before {\n    animation-delay: -0.1s;\n}\n@keyframes sk-fading-circle-delay {\n    0%, 39%, 100% {\n        opacity: 0;\n    }\n    40% {\n        opacity: 1;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
